import { useCallback, useEffect, useMemo, useState } from 'react';
import { useMutation, useQueryClient } from 'react-query';
import { Form, Input, Select, Popconfirm, notification } from 'antd';
import { RuleObject } from 'antd/lib/form';
import srv from '../../../../services';
import AppealFiles from './AppealFiles';
import {
 BaseForm,
 Col,
 SubmitButton,
 Title,
 Alert,
} from '../AppealForm.styled';
import SelectTheme from '../../../_common/SelectTheme';
import ModalNotification from '../ModalNotification/ModalNotification';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useSelector, useDispatch } from 'react-redux';
import { AppDispatch, RootState } from '../../../../store/store';

export default function AppealOfficial() {
 const {
  form,
  isSubmiting,
  error,
  validateAgreement,
  visible,
  handleCancel,
  push,
  ...formProps
 } = useForm();
 const contracts = useContracts();
 const { answerTypes, services, territories } = useDicts();
 const value =
  sessionStorage.getItem('flag') === 'true'
   ? JSON.parse(sessionStorage.getItem('appealForm'))
   : {};

 const [fileSize, setFileSize] = useState<any>(0);
 const [fileSizeAll, setFileSizeAll] = useState<any>(0);
 const [time, setTime] = useState<any>(new Date());
 const [isError, setIsError] = useState<boolean>(false);
 const [fileCounter, setFileCounter] = useState<any>(0);
 const [label, setLabel] = useState(
  'Добавьте дополнительные файлы не более 10 Мб. Количество файлов не более 10.',
 );
 const [color, setColor] = useState('lightgray');
 const [themeChange, setThemeChange] = useState<any>();
 const [serviceIdChange, setserviceIdChange] = useState<any>();

 const appealAttachedFilesData = useSelector(
  (state: RootState) => state.appealAttachedFiles,
  shallowEqual,
 );

 useEffect(() => {
  form.resetFields();
 }, []);

 useEffect(() => {
  const totalSizeCount = fileSizeAll + fileSize;
  const totalFileCount = fileCounter;
  setFileSizeAll(totalSizeCount);
  setFileCounter(totalFileCount);

  sessionStorage.setItem('isError', 'false');

  setIsError(false);
  if (totalSizeCount > 10 * 1024 * 1024) {
   setLabel('Размер файлов превышает 10 МБ.');
   setColor('red');
   sessionStorage.setItem('isError', 'true');
  }

  if (totalFileCount > 10) {
   setLabel('Количество файлов превышает 10.');
   setColor('red');
   sessionStorage.setItem('isError', 'true');
  }

  if (totalSizeCount < 10 * 1024 * 1024 && totalFileCount <= 10) {
   setLabel(
    'Добавьте дополнительные файлы не более 10 Мб. Количество файлов не более 10.',
   );
   setColor('lightgray');
  }

  if (totalSizeCount < 0 && totalFileCount <= 10) {
   setLabel(
    'Добавьте дополнительные файлы не более 10 Мб. Количество файлов не более 10.',
   );
   setColor('lightgray');
  }
 }, [time]);

 useEffect(() => {
  setFileSizeAll(0);
  setLabel(
   'Добавьте дополнительные файлы не более 10 Мб. Количество файлов не более 10.',
  );
  setColor('lightgray');
  //form.resetFields();
  sessionStorage.setItem('isError', 'false');
 }, [themeChange]);

 const SubmitData = () => {
  const fromData = form.getFieldsValue();

  if (form.getFieldsValue()?.files) {
   const sizeAll = form
    .getFieldsValue()
    ?.files.reduce((acc: number, item) => acc + item.size, 0);
   if (sizeAll > 10 * 1024 * 1024) return;
  }

  form.submit();
 };

 /**
  * согласно ЗНР-С-ЛКЮЛ-00000000001440 скрыл от пользователя
  */
 //  return (
 //   <>
 //    <Title>Создание официального обращения</Title>
 //    <BaseForm
 //     form={form}
 //     layout="vertical"
 //     scrollToFirstError
 //     initialValues={value}
 //     {...formProps}
 //    >
 //     <Col>
 //      <Form.Item
 //       name="contractId"
 //       label="№ договора"
 //       rules={[{ required: true }]}
 //      >
 //       <Select
 //        showSearch
 //        allowClear
 //        optionFilterProp="children"
 //        placeholder="Выберите № договора"
 //       >
 //        {contracts.map((item) => (
 //         <Select.Option key={item.id} value={item.id}>
 //          {item.resources
 //           ? `${item.printNumber} - ${item.resources}`
 //           : item.printNumber}
 //         </Select.Option>
 //        ))}
 //       </Select>
 //      </Form.Item>
 //      <SelectTheme setThemeChange={setThemeChange} />

 //      <Form.Item name="serviceId" label="Услуга" rules={[{ required: true }]}>
 //       <Select
 //        showSearch
 //        allowClear
 //        optionFilterProp="children"
 //        placeholder="Выберите услугу"
 //        onChange={setserviceIdChange}
 //       >
 //        {services.map((item) => (
 //         <Select.Option key={item.id} value={item.id}>
 //          {item.name}
 //         </Select.Option>
 //        ))}
 //       </Select>
 //      </Form.Item>

 //      <Form.Item
 //       name="territoryId"
 //       label="Представительство"
 //       rules={[{ required: true }]}
 //      >
 //       <Select
 //        showSearch
 //        allowClear
 //        optionFilterProp="children"
 //        placeholder="Выберите представительство"
 //       >
 //        {territories.map((item) => (
 //         <Select.Option key={item.id} value={item.id}>
 //          {item.name}
 //         </Select.Option>
 //        ))}
 //       </Select>
 //      </Form.Item>
 //     </Col>

 //     <Col flex={1.3}>
 //      <Form.Item name="message" label="Сообщение" rules={[{ required: true }]}>
 //       <Input.TextArea autoSize={{ minRows: 18, maxRows: 22 }} />
 //      </Form.Item>
 //     </Col>

 //     <Col flex={1.2}>
 //      <Form.Item dependencies={['topicId']} noStyle>
 //       {({ getFieldValue }) => (
 //        <AppealFiles
 //         topicId={getFieldValue('topicId')}
 //         serviceId={getFieldValue('serviceId')}
 //         setFileSize={setFileSize}
 //         fileCounter={fileCounter}
 //         setFileCounter={setFileCounter}
 //         setTime={setTime}
 //         label={label}
 //         color={color}
 //        />
 //       )}
 //      </Form.Item>

 //      <Form.Item
 //       name="answerDeliveryId"
 //       label="Выберите удобный способ получения ответа"
 //       rules={[{ required: true }]}
 //      >
 //       <Select>
 //        {answerTypes.map((item) => (
 //         <Select.Option key={item.id} value={item.id}>
 //          {item.name}
 //         </Select.Option>
 //        ))}
 //       </Select>
 //      </Form.Item>
 //      {!!error && <Alert type="error" showIcon message={error} />}

 //      <SubmitButton loading={isSubmiting} onClick={SubmitData}>
 //       Отправить
 //      </SubmitButton>
 //     </Col>
 //    </BaseForm>
 //    <ModalNotification
 //     handleCancel={handleCancel}
 //     visible={visible}
 //     push={() => push('/feedback/appeals')}
 //    >
 //     <Alert message="Обращение успешно создано" type="success" />
 //     <p>
 //      Для перехода к списку ранее созданных обращений нажмите кнопку "Перейти"
 //     </p>
 //    </ModalNotification>
 //   </>
 //  );

 return <div style={{ margin: '80px', fontWeight: 700 }}>Форма недоступна</div>;
}

function useForm() {
 const [form] = Form.useForm();
 const [visible, setVisible] = useState(false);
 const { push } = useHistory();

 const showModal = () => {
  setVisible(true);
 };

 const handleCancel = () => {
  setVisible(false);
 };

 const {
  mutate: save,
  isLoading,
  isSuccess,
  error,
 } = useMutation(srv.saveAppeal, {
  onError: () => {
   notification.error({
    message: 'Предупреждение',
    description: `Аналогичное обращение было подано ранее в личном кабинете.
        Повторное обращение создавать в личном кабинете и других средствах коммуникаций не требуется.
        Ответ будет предоставлен в рамках уже созданного обращения.`,
    duration: 0,
    placement: 'bottomRight',
   });
  },
 });

 const onFinish = useCallback(
  (values) => {
   // (values.serviceId === 1 && values.territoryId === 13) ||
   // (values.serviceId === 2 && values.territoryId === 6) ||
   // (values.serviceId === 2 && values.territoryId === 7) ||
   // (values.serviceId === 2 && values.territoryId === 8) ||
   // (values.serviceId === 2 && values.territoryId === 9)
   //   ? notification.error({
   //       message: "Предупреждение",
   //       description:
   //         "Вы не сможете создать обращение, так как выбранная услуга не обслуживается в данном представительстве",
   //       duration: 10,
   //       placement: "bottomRight",
   //     })
   //   : save(values);

   const isError = sessionStorage.getItem('isError');

   if (isError && JSON.parse(isError) === false) {
    save(values);
   }
  },
  [save],
 );

 useEffect(() => {
  if (isSuccess) {
   showModal();
   sessionStorage.removeItem('appealForm');
  }
  return () => {
   sessionStorage.setItem(
    'appealForm',
    JSON.stringify(form.getFieldsValue(true)),
   );
   sessionStorage.setItem('flag', JSON.stringify(!isSuccess));
  };
 }, [isSuccess, form]);

 const validateAgreement = useCallback(
  (): RuleObject => ({
   validator(_, value) {
    if (value) return Promise.resolve();
    return Promise.reject('Обязательное поле');
   },
  }),
  [],
 );

 return {
  form,
  isSubmiting: isLoading,
  error,
  validateAgreement,
  onFinish,
  visible,
  handleCancel,
  push,
 };
}

function useContracts() {
 const contracts =
  useQueryClient().getQueryData<Models.Contract[]>('contracts');

 return useMemo(() => {
  return contracts.filter((c) => c.state !== 'Расторгнут');
 }, [contracts]);
}

function useDicts() {
 const queryClient = useQueryClient();

 const answerTypes = queryClient.getQueryData<Models.Dict[]>('answerTypes');
 const services = queryClient.getQueryData<Models.Dict[]>('services');
 const territories = queryClient.getQueryData<Models.Dict[]>('territories');

 return { answerTypes, services, territories };
}
